/*
  LOC-072 - country flag images in the localization popout.

  The theme renders one flag per available market (238 of them) inside a popout
  that is closed on load. Chrome's lazy-loading threshold is generous enough that
  it fetched them anyway: 122 KiB on a mobile product page, for a list nobody had
  opened. Firefox held them back, so the cost only showed on Chrome.

  The markup now ships a blank placeholder plus the real URL in data-flag-src.
  This swaps them in the first time a popout is opened, so the flags are there
  before the list is on screen and nothing changes visually.
*/
(function () {
  'use strict';

  function reveal(scope) {
    var imgs = scope.querySelectorAll('img[data-flag-src]');
    for (var i = 0; i < imgs.length; i++) {
      var img = imgs[i];
      img.setAttribute('src', img.getAttribute('data-flag-src'));
      img.removeAttribute('data-flag-src');
    }
  }

  function onInteract(event) {
    var target = event.target;
    if (!target || !target.closest) return;
    var popout = target.closest('popout-select, .popout');
    if (popout) reveal(popout);
  }

  document.addEventListener('click', onInteract, true);
  document.addEventListener('focusin', onInteract, true);
  document.addEventListener('keydown', onInteract, true);
  document.addEventListener('touchstart', onInteract, { passive: true, capture: true });
})();
